//widgets/_new/cards/vendors/distribution/DistributionUnitsSoldCard.tsx
import React, { FC } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTruck } from '@fortawesome/free-solid-svg-icons';

interface Props {
  totalUnitsSold: number;
  averageMonthlySales: number;
}

export const DistributionUnitsSoldCard: FC<Props> = ({totalUnitsSold, averageMonthlySales}) => {
  return (
    <div className="card d-flex flex-column h-auto" style={{background: 'linear-gradient(45deg,#6155D4,#5B97F2)'}}>
      <div className="h-auto rounded-top p-4">
        <header className="" style={{fontSize: '2.5rem'}}>
          <FontAwesomeIcon icon={faTruck} />        
        </header>
        <div className="pt-3 pb-3 d-flex flex-column">
          <div className="fw-bolder" style={{fontSize: '4rem', lineHeight: '1'}}>
            {totalUnitsSold.toLocaleString()}
          </div>
          <div className="pt-2 fw-bold" style={{fontSize: '1.15rem'}}>
            Total Units Sold
          </div>
        </div>
      </div>
      <div style={{ height: '1px', width: 'auto', margin:'0 50% 0 5%', background: 'rgba(255,255,255,0.5)' }}></div>
      <footer className="h-auto rounded-bottom pt-3 pb-3 px-4">
        <div className="d-flex flex-column">
          <div className="fs-1 fw-bold">{averageMonthlySales.toLocaleString()}</div>
          <div className="text-body-secondary fw-bold">Average Monthly Sales</div>
        </div>
      </footer>
    </div>
  )
}